import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsDacha = createSelector(selectJsonQuery, jsonQuery => getTermValue('is_dacha')(jsonQuery));
